'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.request = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reduxActions = require('redux-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST = 'ms/request/request';

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case REQUEST:
      return (0, _extends3.default)({}, action.payload);
    default:
      return state;
  }
}

var request = exports.request = (0, _reduxActions.createAction)(REQUEST);


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/request.js
// module id = 845
// module chunks = 0